import React, { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';
import { RankedItem } from 'services/Ranked';

interface Props {
  cached?: RankedItem;
  isVisible?: boolean;
  loading?: boolean;
  children: React.ReactNode;
}

export type RankedTotalContextType = {
  cached: RankedItem | undefined;
  setCached: Dispatch<SetStateAction<RankedItem | undefined>>;
  isVisible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
};

const RankedTotalContext = createContext<RankedTotalContextType>({
  cached: undefined,
  setCached: () => console.warn('no GroupTotal provider'),
  isVisible: false,
  setIsVisible: () => console.warn('no GroupTotal provider'),
  loading: false,
  setLoading: () => console.warn('no GroupTotal provider'),
});

export function useRankedTotalContext(): RankedTotalContextType {
  return useContext(RankedTotalContext);
}

export function RankedpTotalProvider({ children }: Props): JSX.Element {
  const [cached, setCached] = useState<RankedItem | undefined>(undefined);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <RankedTotalContext.Provider value={{ cached, setCached, isVisible, setIsVisible, loading, setLoading }}>
      {children}
    </RankedTotalContext.Provider>
  );
}
